export const TermsNote = () => (
  <section className="bg-secondary/10 border-t border-border/50 py-10">
    <div className="max-w-3xl mx-auto px-6 text-center">
      <h3 className="font-semibold text-sm text-foreground mb-3">Vertragsbedingungen</h3>
      <div className="text-xs text-muted-foreground space-y-2 leading-relaxed">
        <p>
          <strong>Widerrufsrecht:</strong> Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen
          diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsschlusses.
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Icarus Health, info@icarus-health.de) mittels
          einer eindeutigen Erklärung (z.B. per E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
          informieren.
        </p>
        <p>
          <strong>Kündigung:</strong> Alle Abonnements sind monatlich kündbar zum Ende des jeweiligen
          Abrechnungszeitraums. Eine Kündigung ist jederzeit per E-Mail oder über die Einstellungen möglich.
        </p>
        <p>
          Alle angegebenen Preise verstehen sich als Nettopreise zzgl. der gesetzlichen MwSt. (derzeit 19%).
        </p>
      </div>
    </div>
  </section>
);
